import React, {memo, ReactElement, useRef} from 'react';
import {CSSTransition, SwitchTransition} from 'react-transition-group';
import styles from './styles.module.scss';
import classNames from "classnames";

interface CustomCssTransitionProps {
  bool?: boolean;
  children?: React.ReactNode;
  expanded?: boolean;
  transitionKey?: string;
  className?: string;
}

const CustomCssTransition: React.FC<CustomCssTransitionProps> = ({
                                                                   bool,
                                                                   children,
                                                                   expanded,
                                                                   className,
                                                                   transitionKey
                                                                 }) => {
  const nodeRef = useRef<HTMLDivElement>(null);
  const childCount = React.Children.count(children);
  const childElement: ReactElement =
    childCount === 1
      ? (children as ReactElement)
      : <div>{children}</div>;

  return (
    transitionKey === undefined ? <>
      <SwitchTransition mode="out-in">
        <CSSTransition
          nodeRef={nodeRef}
          key={bool ? 'true' : 'false'}
          timeout={100}
          classNames={{
            enter: styles.fadeEnter,
            enterActive: styles.fadeEnterActive,
            exit: styles.fadeExit,
            exitActive: styles.fadeExitActive,
          }}
        >
          <div ref={nodeRef} style={expanded ? {width: '100%'} : {}} className={classNames(className)}>
            {childElement}
          </div>
        </CSSTransition>
      </SwitchTransition></> : <>
      <SwitchTransition mode="out-in">
        <CSSTransition
          nodeRef={nodeRef}
          key={transitionKey}
          timeout={100}
          classNames={{
            enter: styles.fadeEnter,
            enterActive: styles.fadeEnterActive,
            exit: styles.fadeExit,
            exitActive: styles.fadeExitActive,
          }}
          mountOnEnter
          unmountOnExit
        >
          <div
            ref={nodeRef}
            style={expanded ? {width: '100%'} : undefined}
            className={classNames(className)}
          >
            {childElement}
          </div>
        </CSSTransition>
      </SwitchTransition></>
  );
};

export default memo(CustomCssTransition);